import { ApolloError, useQuery } from '@apollo/client';
import { datadogRum } from '@datadog/browser-rum';
import { Server } from '@src/components/GqlProvider/GqlProvider';
import { Employer, GET_EMPLOYER } from '@src/graphql/profile_edit/queries/userEmployers';

export interface EmployerServiceResponse {
  employmentService_getEmployer: Employer;
}

const useEmployerService = (id?: string) => {
  const onError = (error: ApolloError): void => {
    datadogRum.addError(error, { message: 'There was an error getting the employer.' });
  };

  const { loading, error, data } = useQuery<EmployerServiceResponse>(GET_EMPLOYER, {
    context: {
      server: Server.EMPLOYMENT_SERVICE,
    },
    variables: {
      id,
    },
    skip: !id,
    onError,
  });

  return {
    loading,
    error,
    employer: data?.employmentService_getEmployer,
  };
};

export default useEmployerService;
